<div class="photo-wrapper">
  <app-form-container  [heading]="imageFile() ? 'Change Photo' : 'Upload Photo'" >

    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="onClose()"
    >
      &times;
    </button>

    <div class="account-photo">
      <div
        class="cropper-container"
        [class.invalid-cropper]="getFieldError()"
        [class.drag-over]="isDragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        @if(imageFile()){
        <image-cropper
          [imageFile]="imageFile()!"
          [maintainAspectRatio]="true"
          [roundCropper]="true"
          [alignImage]="'center'"
          [transform]="transform()"
          format="png"
          [resizeToWidth]="100"
          [resizeToHeight]="100"
          (imageCropped)="handleImageCropped($event)"
        ></image-cropper>
        } @else {
        <div class="placeholder">
          <p>Select a photo to crop</p>
        </div>
        }
      </div>

      <div class="info">
        <span class="info-instruction">
          {{
            imageFile()
              ? 'Move the crop area or rotate to frame your photo'
              : 'Drag and drop a photo, or click "Upload Photo" \n to select a photo'
          }}
        </span>
        @if(!getFieldError()){
          <span class="info-types">Allowed file types: .jpg, .jpeg, .png</span>
        }
      </div>

      @if (imageFile()) {
      <div class="editor">
        <div class="zoom">
          <span class="zoom-text">Zoom</span>
          <button
            class="zoom-btn"
            aria-label="Zoom Out"
            matTooltip="Zoom Out"
            (click)="onZoomOut()"
            [disabled]="scale() <= ZOOM_CONFIG.min"
          >
            <mat-icon>remove</mat-icon>
          </button>
          <input
            type="range"
            [min]="ZOOM_CONFIG.min"
            [max]="ZOOM_CONFIG.max"
            [step]="ZOOM_CONFIG.sliderStep"
            [value]="scale()"
            [style.--fill-percent.%]="zoomPercent()"
            (input)="onZoomChange($event)"
          />
          <button
            class="zoom-btn"
            aria-label="Zoom In"
            matTooltip="Zoom In"
            (click)="onZoomIn()"
            [disabled]="scale() >= ZOOM_CONFIG.max"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="editor-actions">
          <button type="button" aria-label="Rotate Photo" (click)="onRotate()">
            <mat-icon>rotate_right</mat-icon>
            <span>Rotate</span>
          </button>

          <button type="button" aria-label="Change Photo" (click)="onUpload()">
            <mat-icon>save_alt</mat-icon>
            <span>Change</span>
          </button>

          <button type="button" aria-label="Remove Photo" class="danger" (click)="onResetState()">
            <mat-icon>delete</mat-icon>
            <span>Remove</span>
          </button>
        </div>
      </div>
      }

      <input
        #fileInput
        type="file"
        accept=".jpg,.jpeg,.png"
        (change)="fileChangeEvent($event)"
        hidden
      />

      @if (getFieldError()) {
      <div class="error-message">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <span>{{ getFieldError() }}</span>
      </div>
      }

      <div class="actions-container">
        @if(!imageFile()){
        <app-button
          buttonVariant="medium-primary"
          buttonType="button"
          ariaLabel="Select Photo"
          (buttonClick)="onUpload()"
        >
          Upload Photo
        </app-button>
        } @else {
        <app-button buttonVariant="photo-secondary" buttonType="button" ariaLabel="Cancel" (buttonClick)="onResetState()">
          Cancel
        </app-button>
        <app-button
          buttonVariant="medium-primary"
          buttonType="button"
          ariaLabel="Save"
          [state]="saveButtonState"
          (buttonClick)="saveCroppedImage()"
        >
          Save
        </app-button>
        }
      </div>
    </div>
  </app-form-container>
</div>
